/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type TagPicker_report = {|
  +id: string;
  +devices: ?$ReadOnlyArray<?{|
    +id: string;
    +tags: ?$ReadOnlyArray<?string>;
  |}>;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TagPicker_report",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "id",
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Device",
      "name": "devices",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "tags",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Report"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/scenes/Report/components/ReportWrapper/components/ReportHeader/components/ReportFilters/components/TagPicker/__generated__/TagPicker_report.graphql.js